import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useState } from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useEmphasizedSnackbarContext } from 'Context/EmphasizedSnackbarContext';
import { followRelationship } from 'Helpers/Affordances';

export function useCancelChurn(relationship) {
  const [isCancelingChurn, setIsCancelingChurn] = useState(false);
  const { refreshPageContentCollection } = usePageContentContext();
  const { clearModalCollection } = useModalContext();

  const { displayErrorMessage } = useSnackbarContext();
  const { displayEmphasizedSnackbar } = useEmphasizedSnackbarContext();

  return {
    async onCancelChurn(e) {
      e.preventDefault();
      e.stopPropagation();
      setIsCancelingChurn(true);
      try {
        const [newCancelChurnResource] = await followRelationship(relationship);
        clearModalCollection();
        displayEmphasizedSnackbar({
          title: newCancelChurnResource.attr('title'),
          description: newCancelChurnResource.attr('description'),
          autoHideDuration: 10000,
        });
        refreshPageContentCollection();
      } catch (err) {
        displayErrorMessage(err, 'An unexpected error occurred. Please try again later.');
      } finally {
        setIsCancelingChurn(false);
      }
    },
    isCancelingChurn,
  };
}
